<template>
    <div class="commissions">
        commissions
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import TrainerLayout from './Layouts/Default'

export default {
    metaInfo() {
        return {
            title:  "Trainer commissions"
        }
    },
    layout: (h, page) => {
      return h(AppLayout, [
        h(TrainerLayout, [page]),
      ])
    },
    props: {
        trainer: Object,
        lang: Object
    },
    data() {
        return {
            form: this.trainer
        }
    },
    methods: {

    }
}
</script>